import React from 'react';
import { Clock } from 'lucide-react';
import { GAME_STATES } from '../../mock/gameData';

const GameStatus = ({ gameState, statusText }) => {
  return (
    <div className="text-center mb-6">
      <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-white">
        <div className="flex items-center justify-center gap-2">
          {gameState === GAME_STATES.AI_THINKING && (
            <Clock className="w-5 h-5 animate-spin" />
          )}
          <p className="text-xl font-semibold">{statusText}</p>
        </div>
      </div>
    </div>
  );
};

export default GameStatus;